var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgInvalidConfiguration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.074,
    cy: 23.145,
    r: 22.781,
    fill: "#E55C42"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.81 29.359h18.787c-.34-1.275-.507-3.065-.63-5.503-.126-2.506-.187-3.422-.345-4.735a29 29 0 0 0-.174-1.233c-.561-3.427-2.728-5.295-6.719-5.673a1.812 1.812 0 1 0-3.052 0c-3.99.378-6.156 2.247-6.718 5.673q-.097.595-.174 1.233c-.158 1.313-.218 2.229-.345 4.734-.122 2.439-.29 4.229-.63 5.503m19.648 1.812H12.949c-.56.64-1.336.906-2.43.906a.906.906 0 1 1 0-1.812c1.424 0 1.855-1.42 2.111-6.5.129-2.55.191-3.49.356-4.86q.08-.677.185-1.31c.606-3.7 2.802-6.005 6.444-6.873a3.625 3.625 0 0 1 7.176 0c3.643.868 5.84 3.173 6.446 6.873q.104.633.185 1.31c.164 1.37.227 2.31.355 4.86.256 5.08.687 6.5 2.111 6.5a.906.906 0 0 1 0 1.812c-1.094 0-1.87-.266-2.43-.906m-13.879 1.812h7.249a3.624 3.624 0 1 1-7.249 0",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.612 7.613h28.994v28.994H9.612z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidConfiguration);
export default __webpack_public_path__ + "static/media/InvalidConfiguration.fdc93838dd8c32be752be85efc26c914.svg";
export { ForwardRef as ReactComponent };